<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">

                <strong>{{ $t('ChartAccountSetting') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton
                    v-if="selected_filter_moein!=0 && !blocked_moein.includes(items_moein.filter(item2 => item2.id == selected_filter_moein)[0].parentId)"
                    @click="add_sub_row()" size="sm" color="primary">
                  <CIcon name="cil-check-circle"/>
                  افزودن تفصیلی
                </CButton>

                <download-excel :data="data_filtered_json"
                                v-if="data_filtered.length>0"
                                name="Chart of Account"
                                :fields="json_fields"
                >
                                  <CButton
                                      class="mr-1"
                                      size="sm"
                                      color="secondary"

                                  >{{ $t("ExportData") }}

                                  </CButton>
                </download-excel>
              </CCol>

            </CRow>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="4">
                <label tag="label" sm="3" class="col-form-label">
                  {{ $t('components.accountingGroup') }}
                </label>
                <CRow form class="form-group">

                  <CCol sm="9">
                    <treeselect
                        v-model="selected_filter_parent"
                        :options="items_parent"
                        :normalizer="normalizer_filter_item"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol col="4">
                <label tag="label" sm="3" class="col-form-label">
                  {{ $t('components.totalAccount') }}
                </label>
                <CRow form class="form-group">

                  <CCol sm="8">
                    <treeselect
                        v-model="selected_filter_child"
                        :options="items_child"
                        :normalizer="normalizer_filter_item"
                    />
                  </CCol>
                  <CCol sm="1">
                    <CIcon
                        @click.native="level_no=11,selected_parent_for_add=selected_filter_child,addGroupModal = true,status_form=0,group_name=''"
                        v-if="selected_filter_child!=0" class="text-success" name="cilPlus"/>

                  </CCol>
                </CRow>
              </CCol>
              <CCol col="4">
                <label tag="label" sm="3" class="col-form-label">
                  {{ $t('components.moenAccount') }}
                </label>
                <CRow form class="form-group">

                  <CCol sm="8">
                    <treeselect
                        v-model="selected_filter_moein"
                        :options="items_moein"
                        :normalizer="normalizer_filter_item"
                    />
                  </CCol>
                  <CCol sm="1">
                    <CIcon v-if="selected_filter_moein!=0"
                           @click.native="level_no=11,selected_parent_for_add=items_moein.filter(item2 => item2.id == selected_filter_moein)[0].parentId,group_name=items_moein.filter(item2 => item2.id == selected_filter_moein)[0].accountName,addGroupModal = true,status_form=selected_filter_moein"
                           class="text-warning" name="cilPencil"/>
                  </CCol>
                </CRow>
              </CCol>


            </CRow>
            <CDataTableFixed
                :items="data_filtered"
                :fields="fields"
                :clickableRows="true"
                :items-per-page="20"
                hover
                sorter
                height="300px"
                :sorter-value="{column:'tafsiliCode',asc:true}"

                column-filter

                @row-clicked="table_row_clicked"
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>

              <template #tafsiliCode="{item}">
                <td>
                  <p style="text-align: center">{{ item.tafsiliCode }}</p>
                </td>
              </template>

              <template #type="{item}">

                <td>
                  <p v-if="item.type != 'undefined'">{{ item.type }}</p>

                </td>

              </template>


              <template #accountGroup="{item}">

                <td>
                  <p>{{ get_item_moien(item) }}</p>

                </td>

              </template>
              <template #moien="{item}">

                <td>
                  <p>{{ get_item_moien2(item) }}</p>

                </td>

              </template>

              <template #vat="{item}">

                <td>
                  <p v-if="item.status != 'undefined'">{{ item.vat }}</p>

                </td>

              </template>
              <template #balance="{item}">

                <td>
                  <p v-if="item.status != 'undefined'">{{ item.vat }}</p>

                </td>

              </template>
              <template #status="{item}">

                <td>
                  <p v-if="item.isActive == 'undefined'"></p>
                  <p v-if="item.isActive != 1"> <CIcon class="text-success" name="cil-check"/></p>
                  <p v-if="item.isActive != 0"> <CIcon  name="cil-check"/></p>
                </td>

              </template>


            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>

    </CRow>

    <CModal
        :show.sync="addGroupModal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        :show_footer="false"
        :title="$t('buttons.addAccountingGroup')"
    >

      <CRow>
        <CCol col="12">
          <CInput
              :label="$t('components.groupName')"
              horizontal

              v-model="group_name"
          />
          <CInput
              :label="$t('components.tax')"
              horizontal
              append="%"
              addInput
              addInputClasses="text-end"
              v-model="group_vat"
          />
          <CRow class="form-group form-row">
            <CCol col="3" style="text-align: end">
              <label>{{ $t('components.visibility') }}</label>
            </CCol>
            <CCol col="9">
              <CInputCheckbox
                  :checked.sync="edit_group_visibility"
              />
              <CSwitch
                  color="success"

                  :value="edit_group_visibility"
              />
            </CCol>
          </CRow>

          <CRow class="form-group form-row">
            <CCol col="3" style="text-align: end">
              <label></label>
            </CCol>
            <CCol col="9">
              <label>{{ selected_node_parents }}</label>
            </CCol>
          </CRow>


        </CCol>
      </CRow>
      <CRow >
        <CCol style="    text-align: end;">
          <!--         status is: {{status_form}}-->
          <!--          parent is: {{selected_parent_for_add}}-->
          <CButton @click="insert_data()" class="m-1"
                   color="secondary"
          >{{ $t("buttons.ok") }}
          </CButton>
          <CButton class="m-1"
                   @click="addGroupModal = false,status_form= 0"
                   color="secondary"
          >{{ $t("buttons.cancel") }}
          </CButton>
        </CCol>
      </CRow>

      <template #footer>

        <!--        <CButton-->
        <!--            @click="addGroupModal = false,status_form= 0"-->
        <!--            color="danger"-->
        <!--        >{{ $t("buttons.cancel") }}-->
        <!--        </CButton>-->
      </template>

      <template #footer-wrapper style="display: none">

        <label
            @click="addGroupModal = false,status_form= 0"
            color="danger"
        >
        </label>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Vue from "vue";
import JsonExcel from "vue-excel-ultra";

Vue.component("downloadExcel", JsonExcel);

export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {

    return {
      addGroupModal: false,
      group_code: '',
      group_name: '',
      group_vat: '',
      group_nature: '',
      group_type: '',
      group_parent: 0,
      items_types: [],

      items_natures: [],
      items_parent: [],
      selected_filter_parent: 0,
      items_child: [],
      selected_filter_child: 0,
      selected_filter_moein: 0,
      items_moein: [],
      data_filtered: [],
      data: [],
      data_moeins: [],
      level_no: 0,
      fields: [
        // {key: 'id', label: "id", _style: 'width:2%'},
        // {key: 'parentId', label: "parentId", _style: 'width:2%'},
        {key: 'tafsiliCode', label: this.$t('tables.code'), _style: 'width:2%'},
        {key: 'title', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        // {key: 'nature', label: this.$t('tables.nature'), _style: 'width:10%'},
        // {key: 'type', label: "ماهیت", _style: 'width:5%'},
        {key: 'groupName', label: this.$t('AccountsGroup'), _style: 'width:3%'},
        {key: 'totalName', label: this.$t('components.totalAccount'), _style: 'width:4%'},
        {key: 'accountName', label: this.$t('components.moenAccount'), _style: 'width:4%'},
        // {key: 'balance', label: this.$t('tables.balance'), _style: 'width:3%'},

        {key: 'natureTitle', label: this.$t('nature'), _style: 'width:3%'},
        {key: 'vat', label: this.$t('tables.tax'), _style: 'width:3%'},
        {key: 'status', label: this.$t('tables.status'), _style: 'width:3%'},
        // {key: 'natureTitle', label: this.$t('nature'), _style: 'width:3%'},

        // {key: 'nature', label: this.$t('tables.status'), _style: 'width:3%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],


      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',
      file: '',

      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      blocked_moein: [10, 11, 140, 13, 15, 30],
      edit_group_name: '',
      edit_group_nature: 0,
      edit_refer_person: null,
      edit_group_code: '',
      selected_template: 0,
      selected_node_parents: '',
      table_clicks: 0,
      table_clicks_timer: null,
      status_form: 0,
      selected_parent_for_add: 0,
      edit_group_visibility: false,
      normalizer_persons(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,

        }
      },
      normalizer_filter_item(node) {
        return {
          id: node.id,
          label: node.accountCode+" "+node.accountName,
          children: node.children,

        }
      },
    }
  },
  mounted() {

    this.$root.root_validate_errors = [];


    this.get_all_docs();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    'selected_filter_parent': function () {
      this.selected_filter_child = 0;
      this.filter_data();


    },
    'selected_filter_child': function () {
      this.filter_data();
      this.selected_filter_moein = 0;

      var objects = this.get_parent(this.selected_filter_child).reverse();
      this.selected_node_parents = ''
      for (var i = 0; i < objects.length; i++) {
        this.selected_node_parents += " - " + objects[i]
      }
    },
    'selected_filter_moein': function () {
      this.filter_data();

      var objects = this.get_parent(this.selected_filter_moein).reverse();
      this.selected_node_parents = ''
      for (var i = 0; i < objects.length; i++) {
        this.selected_node_parents += " - " + objects[i]
      }
    },
    'group_nature': function () {
      this.filter_data();


    },
    'group_type': function () {
      this.filter_data();


    },

    'refer_person': function () {
      var objects = this.get_parent(this.refer_person).reverse();
      for (var i = 0; i < objects.length; i++) {
        this.selected_node_parents += " - " + objects[i]
      }
    }
  },
  computed:{
    data_filtered_json(){
var array = []
      var self = this
      this.data_filtered.forEach(function (val) {
        array.push({
          tafsiliCode: val.tafsiliCode,
          title: val.title,
          groupName:val.groupName,
          totalName:val.totalName,
          accountName:val.accountName,
          vat:val.vat
        })
      })
      return array

    },
    json_fields() {
      return {
        'Code': 'tafsiliCode',
        'Account Title': 'title',
        'Accounts Group': 'groupName',
        'General Ledger Accounts': 'totalName',
        'Subsidiary': 'accountName',
        'Vat': 'vat',
      }
    },
  },
  methods: {
    export_data(){

    },
    get_item_accountGroup(item) {
      if (item != null) {
        return this.get_parent(item.parentId)[2];

      } else {
        return "";
      }
    },
    get_item_moien(item) {
      if (item != null) {
        return this.get_parent(item.parentId)[1];

      } else {
        return "";
      }
    },
    get_item_moien2(item) {
      if (item != null) {
        return this.get_parent(item.parentId)[0];

      } else {
        return "";
      }
    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        console.log('dblclick' + JSON.stringify(item));
        // this.addGroupModal = true
        var name = item.accountName.replaceAll("/", "|");
        // this.$router.push({path: '/dashboard/accounting/accounting-page/' + name})
        // this.group_nature = item.accNature
        // this.refer_person = item.id
        // this.table_clicks = 0;
        // this.status_form = item.id
        // this.edit_group_name = item.accountName
        // this.edit_group_nature = item.accNature
        // this.edit_refer_person = item.parentId
        // this.edit_group_code = item.accountCode
      }

    },
    get_parent(itemParentId) {
// if(itemParentId !=0){
      var parents = [];
      this.data.forEach((val) => {
        if (val.id == itemParentId) {
          parents.push(val.accountName)
          this.get_parent(val.parentId).forEach((val2) => {
            parents.push(val2)

          });
        }
      });
      return parents;

// }
    },
    get_all_docs() {
      this.get_lists_natures();

      // this.get_lists_pay();

    },
    add_sub_row() {
      if (this.selected_filter_moein != 0 && this.selected_filter_moein != null) {
        this.addGroupModal = true;
        this.group_name = "",
            this.level_no = 12,
            this.selected_parent_for_add = this.selected_filter_moein
      } else {
        this.$root.modal_component.show_danger_modal(this.$t('dialogs.error'), this.$t('selectMoeinDialog'));

      }
    },
    go_to_detailed(item) {

      this.$router.push({path: '/dashboard/accounting/detailed-accounting-groups/' + item.id});

    },
    filter_data() {
      var self = this;
      this.items_child = [{accountName: this.$t('all'),accountCode:"", id: 0}]
      this.items_moein = [{accountName: this.$t('all'),accountCode:"" ,id: 0}]
      this.items_parent = [{accountName: this.$t('all'),accountCode:"", id: 0}]
console.log("self data all is ",self.data);

      this.data_filtered = [];
      // this.data_filtered = this.data;
      var all_data_sub_4 = [];
      this.data.forEach((val) => {
        if (val.parentId == 0) {
this.items_parent.push(val);
          self.get_childrens_one_sub(val.id, self.data).forEach((val1) => {
            //get hesab kol
            if (this.selected_filter_parent == 0) {

              self.items_child.push(val1)
            } else if (val1.parentId == self.selected_filter_parent) {
              self.items_child.push(val1)
            }

            self.get_childrens_one_sub(val1.id, self.data).forEach((val2) => {
              //get moeins
              if (this.selected_filter_child == 0) {
                self.items_moein.push(val2)
              } else if (val2.parentId == self.selected_filter_child) {
                self.items_moein.push(val2)
              }
              // console.log("val is ",val2.id)

            });
          });
        }
      });
      console.log("tafziliiiis is",self.data_moeins.length);
      self.data_moeins.forEach((val3) => {
        //get all filtered data
        var checked = true;
        if (this.selected_filter_parent != 0 && val3.groupId != self.selected_filter_parent) {
          checked = false;
        }
        if (this.selected_filter_moein != 0 && val3.accountId != self.selected_filter_moein) {
          checked = false;
        }
        if (this.selected_filter_child != 0 && self.items_moein.filter(e => e.id === val3.accountId).length == 0) {
          checked = false;
        }
        if (checked) {

          all_data_sub_4.push(val3)

        }
      });
      // if (this.selected_filter_parent == 0) {
      //
      this.data_filtered = all_data_sub_4;

    },
    get_lists_groups() {
      var self = this;
      self.items_parent = [];
      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              // self.items_receive = content_data.data.map((item, row_id) => {
              //   return {...item, row_id}
              //
              // });

              response.data.data.forEach((val) => {
                if (val.accNature == 1) {
                  val.nature = self.$t('debtor');
                }
                if (val.accNature == 2) {
                  val.nature = self.$t('creditor');
                }
                if (val.accNature == 3) {
                  val.nature = self.$t('neutral');
                }
                if (val.accNature == 0) {
                  val.nature = '';
                }

                if (val.accType == 1) {
                  val.type = self.$t('permanent');
                }
                if (val.accType == 2) {
                  val.type = self.$t('temporary');
                }
                if (val.accType == 0) {
                  val.type = '';
                }


                if (val.accType == 1) {
                  val.type = self.$t('bedehkar');
                }
                if (val.accType == 2) {
                  val.type = self.$t('bestankar');
                }
                if (val.accType == 3) {
                  val.type = self.$t('bestankar_bedehkar');
                }
                if (val.accType == 0) {
                  val.type = '';
                }
              });
              self.data = response.data.data.map((item, row_id) => {
                return {...item, row_id}
              })
/////////////////////filter parent/////////////

              /////////////////end fiter parent////////////////

              self.get_lists_moeins();

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
            }
          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_moeins() {
      var self = this;
      self.items_parent = [];
      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "GetAllAccountTafsiliList";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              self.data_moeins = response.data.data.map((item, row_id) => {
                return {...item, row_id}
              })
/////////////////////filter parent/////////////

              /////////////////end fiter parent////////////////

              self.filter_data();

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
            }
          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          var obj = {
            name: val2.accountName, name_code: val2.accountName + " (" + val2.accountCode + ")",
            code: val2.accountCode, id: val2.id, children: this.get_childrens(val2.id, list), nature: val2.nature,
            type: val2.type,
            parentId: val2.parentId,
          }
          array.push(obj);
          // val2.inserted = true;

        }
      });
      return array;
    },
    get_childrens_row(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          array.push(val2);
          self.get_childrens_row(val2.id, list).forEach((val3) => {

            array.push(val3);
            // val2.inserted = true;
          });

        }
      });
      return array;
    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      list.forEach((val2) => {
        if (parent_id == val2.parentId) {
          var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);
        }
      });
      return array;
    },
    get_childrens_one_sub_tree(parent_id, list) {
      var array = [];
      list.forEach((val2) => {
        if (parent_id == val2.parentId) {
          var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(obj);
        }
      });
      return array;
    },
    get_lists_types() {
      var self = this;

      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_SysAccountTypes";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_types = [];
          var obj = {label: "select", value: 0};
          self.items_types.push(obj);

          response.data.data.forEach((val) => {
            var obj = {label: val.accTypeTitle, value: val.accTypeId};
            self.items_types.push(obj);

          });
          self.group_type = 0
          self.get_lists_groups();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_natures() {
      var self = this;


      const formData = new FormData();
      var url = "Get_SysAccountNatures";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_natures = [];
          var obj = {accountName: "All", id: 0};
          self.items_natures.push(obj);

          response.data.data.forEach((val) => {
            var obj = {accountName: val.accNatureTitle, id: val.accNatureId};
            self.items_natures.push(obj);

          });
          self.group_nature = 0;

          self.get_lists_types();
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.group_name != '') {
        return true;
      }


      // if (this.group_code == 0) {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertCode'));
      // }
      if (this.group_name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      url = "Add_AccountingGroup";

      formData.append('AccountId', this.status_form)

      formData.append('AccountName', this.group_name);
      formData.append('AccountCode', this.group_code);
      formData.append('AccType', this.group_type);
      formData.append('AccNature', this.group_nature);
      formData.append('ParentId', this.selected_parent_for_add);
      formData.append('LevelNo', this.level_no);
      self.addGroupModal = false;

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.group_parent = 0;
        self.group_name = '';
        self.group_code = '';
        self.get_all_docs();
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  },

}

</script>
<style>
.zk-table__cell-inner {
  text-align: initial;
}
</style>
